import * as React from 'react';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) => ({
  root: {
    fontSize: theme.spacing(4),
    margin: theme.spacing(2)
  }
});

type Props = WithStyles<typeof styles> & Omit<SvgIconProps, 'component' | 'shapeRendering'>;

const ErrorIconComponent: React.FC<Props> = ({ classes, className = '', ...props }) => (
  <ErrorOutlineIcon className={`${classes.root} ${className}`} {...props} />
);

export const ErrorIcon = withStyles(styles)(ErrorIconComponent);
